import React from "react";
import "../styles/AppStoreLinks.css";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/craft-the-social-beer-app/id6444923219";
const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.vivinobrothers.craft_thesocialbeerapp";

const AppStoreLinks = ({ compact = false }) => (
  <div className={`store-links${compact ? " store-links--compact" : ""}`}>
    <a
      className="store-link"
      href={APP_STORE_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Download CRAFT on the App Store"
    >
      <span className="store-link__eyebrow">Download on the</span>
      <span className="store-link__name">App Store</span>
    </a>
    <a
      className="store-link"
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Get CRAFT on Google Play"
    >
      <span className="store-link__eyebrow">Get it on</span>
      <span className="store-link__name">Google Play</span>
    </a>
  </div>
);

export default AppStoreLinks;
